import {
	IonPage,
	IonHeader,
	IonToolbar,
	IonTitle,
	IonContent,
	IonGrid,
	IonRow,
	IonButtons,
	IonSlides,
	IonSlide,
	IonButton,
	withIonLifeCycle,
	IonIcon,
	IonLabel,
	IonCol
} from '@ionic/react';
import React from 'react';
import BarElement, { BarData, BarSalesData } from '../components/BarElement';
import Loading from '../components/Loading';
import { RouteComponentProps } from 'react-router';
import AuthenticationStore from '../mobx/AuthenticationStore';
import SalesDataStore from '../mobx/SalesDataStore';
import CustomersStore from '../mobx/CustomersStore';
import { observer } from 'mobx-react';
import { arrowBack } from 'ionicons/icons';
import { PATH_LOGIN, PATH_CUSTOMERS } from '../common/Constants';
import { getformatNumber } from '../common/utils';

import '../theme/pages/currentStatus.css';
import AppStore from '../mobx/AppStore';

type MatchParams = {
	obfuscatedIds?: string
}

interface Props extends RouteComponentProps<MatchParams> {
	authenticationStore: AuthenticationStore;
	customersStore: CustomersStore;
	salesDataStore: SalesDataStore;
	appStore: AppStore;
}

type State = {
	isHidden: boolean,
	isLoading: boolean,
	selectedBarData: BarData | null
}

type Member = {
	isMounted: boolean
}

@observer
class CurrentStatus extends React.Component<Props, State> {

	private barDataList: Array<BarData> = [
		{
			barNumber: 0,
			name: "Sales",
			color: "rgba(85, 185, 255, 1)"
		},
		{
			barNumber: 1,
			name: "Points",
			color: "rgba(0, 145, 255, 1)"
		},
		{
			barNumber: 2,
			name: "Growth",
			color: "rgba(0, 74, 130, 1)"
		}
	]

	state: State = {
		isHidden: true,
		isLoading: true,
		selectedBarData: null
	}

	member: Member = {
		isMounted: false
	}

	ionViewDidEnter() {
		this.member.isMounted = true;
		this.props.authenticationStore.isValid()
			.then((isValid) => {
				if (this.member.isMounted) {
					if (isValid) {
						if (this.props.authenticationStore.isAdmin()) {
							if (this.props.match.params.obfuscatedIds !== undefined) {
								this.setState({ isHidden: false });
								this.props.customersStore.getCurrentCustomer(this.props.match.params.obfuscatedIds);
								this.props.salesDataStore.fetch(this.props.match.params.obfuscatedIds)
									.finally(() => {
										this.setState({ isLoading: false });
									});
							} else {
								this.props.history.replace(PATH_CUSTOMERS);
							}
						} else {
							this.setState({ isHidden: false });
							this.props.customersStore.getCurrentCustomer();
							this.props.salesDataStore.fetch()
								.finally(() => {
									this.setState({ isLoading: false });
								});
						}
					} else {
						this.props.history.replace(PATH_LOGIN);
					}
				}
			})
			.catch(() => {
				this.props.history.replace(PATH_LOGIN);
			});
	}

	ionViewWillLeave() {
		this.member.isMounted = false;
	}

	setSelectedBarData = (selectedBarData: BarData | null) => {
		this.setState({ selectedBarData: selectedBarData });
	}
	
	getBar = (barData: BarData, barSalesData: BarSalesData, isClickable: boolean) => {
		return <BarElement
			key={barData.barNumber}
			barData={barData}
			barSalesData={barSalesData}
			setSelectedBarData={(this.setSelectedBarData)}
			chartReference={React.createRef()}
			isClickable={isClickable}
			hasNoData={this.props.salesDataStore.hasNoData}>
		</BarElement>
	}

	getBarSideData = (barData: BarData, barSalesData: BarSalesData, prefix: string) => {
		return <IonGrid className="bar-side-data">
			<IonRow >Minimum Threshold: </IonRow>
			<IonRow >{prefix}{getformatNumber(barSalesData.goal,0)}</IonRow>
			<IonRow >Projected Sales: </IonRow>
			<IonRow >{prefix}{getformatNumber(barSalesData.projected,0)}</IonRow>
			<IonRow >% of goal: </IonRow>
			<IonRow >{getformatNumber((barSalesData.ytd / barSalesData.goal) * 100, 2)}%</IonRow>
			<IonRow >Current {barData.name}: </IonRow>
			<IonRow >{prefix}{getformatNumber(barSalesData.ytd,0)}</IonRow>
		</IonGrid>
	}

	getBarSideDataLess = (barData: BarData, barSalesData: BarSalesData, prefix: string) => {
		if(this.props.salesDataStore.hasNoData){			
			return <IonGrid className="bar-side-data">
				<IonRow >Current {barData.name}: </IonRow>
				<IonRow >{prefix}{getformatNumber(barSalesData.ytd,0)}</IonRow>
			</IonGrid>
		}
		return <IonGrid className="bar-side-data">
			<IonRow >Minimum Threshold: </IonRow>
			<IonRow >{prefix}{getformatNumber(barSalesData.goal,0)}</IonRow>
			<IonRow >Current {barData.name}: </IonRow>
			<IonRow >{prefix}{getformatNumber(barSalesData.ytd,0)}</IonRow>
		</IonGrid>
	}

	render() {
		return (
			<IonPage className="current-status">
				{!this.props.appStore.isWeb ?
					<>
						<IonHeader>
							<IonToolbar className="header-toolbar">
								{this.state.selectedBarData == null ?
									<IonButtons slot="start">
										<IonButton onClick={() => { this.props.history.goBack(); }}><IonIcon icon={arrowBack} /></IonButton>
									</IonButtons> :
									<IonButtons slot="start">
										<IonButton onClick={() => this.setSelectedBarData(null)}><IonIcon icon={arrowBack} /></IonButton>
									</IonButtons>
								}
								<IonTitle className="toolbar-title">Current Status</IonTitle>
							</IonToolbar>
							<div className="curve-static"></div>
						</IonHeader>
					</>
					:
					<>
						<IonHeader>
							<IonToolbar className='header-toolbar'>
								<>
									{this.state.selectedBarData == null ?
										<></> :
										<IonButtons slot="start">
											<IonButton onClick={() => this.setSelectedBarData(null)}><IonIcon icon={arrowBack} /></IonButton>
										</IonButtons>
									}
									<IonTitle  className="toolbar-title" >Current Status</IonTitle>
								</> 
							</IonToolbar>
						</IonHeader>
					</>
				}
				{this.state.isHidden ? null :
					<>
						<IonContent>
						<IonGrid className="custom-width">
								<IonRow>
									<IonCol className="name">
										{this.props.customersStore.currentCustomer?.name}
									</IonCol>
								</IonRow>
								{this.props.customersStore.currentCustomer?.branchNumber &&
								<IonRow>
									<IonCol>
										<IonLabel className="name">Branch #{this.props.customersStore.currentCustomer?.branchNumber}</IonLabel>
									</IonCol>
								</IonRow>
								}
							</IonGrid>
							{this.state.selectedBarData == null ?
								<IonGrid className="bar-grid forheight">
									<IonRow className="bar-row forheight">
										{this.props.salesDataStore.barSalesDataList.map((it: BarSalesData, i: number) => {
											{/* Note: remove for now data for this year, hide growth */}
											if(i != 2)
												return this.getBar(this.barDataList[i], it, true);
										})}
									</IonRow>
								</IonGrid>
								:
								<div className="forheight">
									<IonSlides className="forheight bar-slides" pager={true} options={{ initialSlide: this.state.selectedBarData.barNumber }}>
										<IonSlide>
											{this.getBar(this.barDataList[0], this.props.salesDataStore.barSalesDataList[0], false)}
											{/* Note: remove for now data for this year, hide growth */}
											{/* {this.getBarSideData(this.barDataList[0], this.props.salesDataStore.barSalesDataList[0],'$')} */}
											{this.getBarSideDataLess(this.barDataList[0], this.props.salesDataStore.barSalesDataList[0],'$')}
										</IonSlide>
										<IonSlide>
											{this.getBar(this.barDataList[1], this.props.salesDataStore.barSalesDataList[1], false)}
											{/* Note: remove for now data for this year, hide growth */}
											{/* {this.getBarSideData(this.barDataList[1], this.props.salesDataStore.barSalesDataList[1],'')} */}
											{this.getBarSideDataLess(this.barDataList[1], this.props.salesDataStore.barSalesDataList[1],'')}
										</IonSlide>
										{/* Note: remove for now data for this year, hide growth */}
										{/* <IonSlide>
											{this.getBar(this.barDataList[2], this.props.salesDataStore.barSalesDataList[2], false)}
											{this.getBarSideData(this.barDataList[2], this.props.salesDataStore.barSalesDataList[2],'$')}
										</IonSlide> */}
									</IonSlides>
								</div>
							}
						</IonContent>
					</>}
				{(this.state.isLoading) && <Loading />}
			</IonPage>
		);
	}
};

export default withIonLifeCycle(CurrentStatus);